<template>
  <div>
    <van-row class="contentStyle ">
      <van-col
        span="2"
        style="line-height: 30px"
        onclick="window.history.go(-1)"
      >
        <van-icon
          name="arrow-left"
          style="padding-top: 5px"
          color="#ffffff"
          size="27px"
        />
      </van-col>
      <van-col span="20" style="text-align: left">
        <div id="searchBar">
          <van-field
            v-model="search"
            style="
              padding: 0px 10px;
              line-height: 30px;
              height: 30px;
              background-color: #ffffff;
              color: #646566;
              border: 1px solid #ffffff;
              border-radius: 6px;
            "
          />
        </div>
      </van-col>
      <van-col span="2"> </van-col>
    </van-row>

    <div class="searchRow">
      <van-row v-for="(item, index) in dataList" :key="index">
        <van-col
          span="24"
          style="border-bottom: 1px solid #c8c9cc"
          @click="showStock(item)"
        >
          <p class="shareName">{{ item.name }}</p>
          <p class="shareCode">{{ item.code }}</p>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "TradingSearchStock",
  data() {
    return {
      search: "",
      dataList: [],
      favDataList: [],
    };
  },
  watch: {
    search: function (val) {
      this.query_stocks(val);
    },
  },
  methods: {
    showStock(item) {
      switch (this.$route.params.route) {
        case "kline":
          this.$router.push({ name: "Kline", params: { code: item.short } });
          break;

        default:
          this.$store.commit("setSearchSecltedShare", item.short);
          this.$router.go(-1);
          break;
      }
    },
    query_stocks(query) {

      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "get_stocks",
            words: query.toUpperCase(),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var dataArr = res.data.data;
            if (dataArr.length != 0) {
              that.dataList = [];
              $.each(dataArr, function (index, item) {
                var result = {
                  name: item.name,
                  short: item.short,
                  code: item.code,
                };
                that.dataList.push(result);
              });
            } else {
              that.dataList = that.favDataList;
            }
          } else if (res.data.code === 0) {
            that.$toast.fail(res.data.msg);
          } else if (res.data.code === -1) {
            that.$logout(res.data.msg);
          }
        });
    },
    loadFavList() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "concern",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var dataArr = res.data.data;
            if (dataArr.length != 0) {
              that.favDataList = [];
              $.each(dataArr, function (index, item) {
                var fav = {
                  name: item.name,
                  short: item.short,
                  code: item.code,
                };
                that.favDataList.push(fav);
              });
              that.dataList = that.favDataList;
            } else {
              that.favDataList = [];
            }
          } else if (res.data.code === 0) {
            that.$toast.fail(res.data.msg);
          } else if (res.data.code === -1) {
            that.$logout(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.loadFavList();
  },
};
</script>

<style scoped>
.contentStyle {
  background-color: #ee0a24;
}

#searchBar {
  padding-top: 6px;
}

.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.searchRow {
  color: #000000;
  padding-left: 10px;
  padding-right: 10px;
}

.shareName {
  margin-top: 6px;
  margin-bottom: 2px;
}

.shareCode {
  margin-top: 2px;
  margin-bottom: 6px;
}
</style>

<style>
#searchBar .van-field__control {
  color: #646566 !important;
  font-size: 14px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/TradingSearchStock.vue